import { Button } from 'primereact/button';
import '../App.css';
import { InputText } from 'primereact/inputtext';

function CampaignNewStepMaxSeconds({
    setStep,
    title,
    creativeURL,
    previewURL,
    maxSecondsToDisplay,
    setMaxSecondsToDisplay,
    createCampaign,
}) {
    return (
        <div>
            <div>
                <h3>
                    Time to display (seconds)
                </h3>
                <InputText
                    value={maxSecondsToDisplay}
                    onChange={(e) => setMaxSecondsToDisplay(e.target.value)}
                    placeholder='max time to display (seconds)'
                    type='number'
                />
            </div>
            <div style={{ marginTop: '1em' }}>
                <Button
                    label="Back"
                    severity="secondary"
                    onClick={
                        () => {
                            if (!previewURL) {
                                setStep('upload');
                                return;
                            }
                            setStep('preview');
                        }
                    }
                    size='small'
                    outlined
                />
                <Button
                    label="Finish"
                    severity="success"
                    onClick={createCampaign}
                    disabled={title == '' || creativeURL == ''}
                    style={{ marginLeft: '0.5em' }}
                    size='small'
                    outlined
                />
            </div>
        </div>
    );
}

export default CampaignNewStepMaxSeconds;